module.exports = __webpack_public_path__ + "img/组29.1127fa40.png";